var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from 'axios';
export const processResponse = (cartData, triggerEvent = true) => {
    const lineItems = cartData.items;
    const count = cartData.item_count;
    if (triggerEvent) {
        cartUpdated(lineItems, count);
    }
    return cartData;
};
export const get = (triggerEvent = true) => {
    return axios.get('/cart.js').then((res) => {
        return processResponse(res.data, triggerEvent);
    });
};
const cartUpdated = (items, count) => {
    window.dispatchEvent(new CustomEvent('cart-updated', {
        detail: {
            items,
            count,
        },
    }));
};
export const add = (items, quizLogic = true) => {
    if (items.length === 0) {
        return new Promise(() => { });
    }
    if (window.quizId) {
        items.map((item) => {
            item.properties = Object.assign(Object.assign({}, item.properties), { _quiz_kit_id: window.quizId });
        });
    }
    const formData = {
        items,
    };
    return fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
    })
        .then((res) => __awaiter(void 0, void 0, void 0, function* () {
        if (res.ok) {
            yield get();
            // Shopify only returns and array with { "items": []} when using add, the rest of the endpoints return the full Cart object
            const resData = yield res.json();
            const lineItems = resData === null || resData === void 0 ? void 0 : resData.items;
            lineItems.map((item) => {
                if (!quizLogic)
                    return;
                fetch(`https://api.quizkitapp.com/api/v1/quizzes/${window.quizKey}/add-to-cart`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        price: item.price,
                        variantId: item.id,
                        source: 'quiz_result'
                    }),
                });
            });
            window.dispatchEvent(new CustomEvent('cart-added-item'));
            return lineItems;
        }
        return res.json();
    }))
        .catch((error) => {
        console.error(error);
    });
};
export const update = (updates, attributes = {}) => {
    if (Object.keys(updates).length === 0 && Object.keys(attributes).length === 0) {
        return;
    }
    return axios
        .post('/cart/update.js', {
        updates,
        attributes,
    })
        .then((res) => {
        return processResponse(res.data);
    })
        .catch((error) => {
        console.error(error.toJSON());
        return error;
    });
};
export const deleteItems = (deletes) => {
    if (Object.keys(deletes).length === 0) {
        return;
    }
    const updates = {};
    deletes.forEach((id) => {
        updates[id] = 0;
    });
    return update(updates);
};
export const empty = () => {
    return axios.post('/cart/clear.js').then((res) => {
        return processResponse(res.data);
    });
};
export default {
    get,
    add,
    update,
    delete: deleteItems,
    empty,
};
